import { getTranslatedProperty, getCategoryUrl, getProductUrl } from '@shopware-pwa/helpers-next';
import { useCategorySearch, useProductSearch, useLandingSearch } from '#imports';

export function useNavigationElement(navigationElement) {
    const { search: searchCategory } = useCategorySearch();
    const { search: searchProduct } = useProductSearch();
    const { search: searchLanding } = useLandingSearch();
    const isExternalLink =
        getTranslatedProperty(navigationElement, 'linkType') === 'external' ||
        navigationElement.linkType === 'external';

    const isCategoryLink =
        getTranslatedProperty(navigationElement, 'linkType') === 'category' ||
        navigationElement.linkType === 'category';

    const isProductLink =
        getTranslatedProperty(navigationElement, 'linkType') === 'product' || navigationElement.linkType === 'product';

    const isLandingPageLink =
        getTranslatedProperty(navigationElement, 'linkType') === 'landing_page' ||
        navigationElement.linkType === 'landing_page';

    const isInternalLink = isProductLink || isCategoryLink || isLandingPageLink;

    const linkNewTab = getTranslatedProperty(navigationElement, 'linkNewTab') || navigationElement.linkNewTab;

    const externalLink = getTranslatedProperty(navigationElement, 'externalLink') || navigationElement.externalLink;

    const internalLink = getTranslatedProperty(navigationElement, 'internalLink') || navigationElement.internalLink;

    const path = ref('');

    const getInternalRoute = async () => {
        if (!internalLink) {
            return;
        }
        if (isCategoryLink) {
            const categoryResponse = await searchCategory(internalLink);

            if (!categoryResponse) {
                return;
            }

            path.value = getCategoryUrl(categoryResponse);
        } else if (isProductLink) {
            const productResponse = await searchProduct(internalLink);

            if (!productResponse || !productResponse?.product) {
                return;
            }

            path.value = getProductUrl(productResponse.product);
        } else if (isLandingPageLink) {
            const landingPageResponse = await searchLanding(internalLink);

            if (!landingPageResponse) {
                return;
            }

            path.value = getTranslatedProperty(landingPageResponse, 'url');
        }
    };

    return {
        isExternalLink,
        isInternalLink,
        linkNewTab,
        externalLink,
        internalLink,
        getInternalRoute,
        path,
    };
}
